import React from "react";

import { ThreeUpCardBlock as Value } from "@reactivated";

import { delegateClickToLink } from "../../utils/delegateClickToLink";
import { Clickable } from "../Clickables";
import { MediaChooserBlock } from "../MediaChooserBlock";

import styles from "./ThreeUpCard.module.scss";

interface Props {
    value: Value;
}

export const ThreeUpCard = ({ value }: Props) => {
    if (!value.media) return <></>;

    const linkUrl = value.link?.url;

    const captionContent = (
        <>
            <span className={styles.title}>{value.title}</span>
            {value.subtitle && (
                <span className={styles.subtitle}>{value.subtitle}</span>
            )}
        </>
    );

    return (
        <figure className={styles.card} onClick={delegateClickToLink}>
            <MediaChooserBlock
                value={value.media}
                wrapperAttrs={{ className: styles.media }}
                imageProps={{ sizes: styles.sizes }}
            />
            <figcaption className={styles.caption}>
                {linkUrl ? (
                    <Clickable href={linkUrl} className={styles.captionLink}>
                        {captionContent}
                    </Clickable>
                ) : (
                    captionContent
                )}
            </figcaption>
        </figure>
    );
};
